import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'StartTrialButton' })({
    root: {
        color: '#fff',
        background: 'transparent !important',
        border: '1.5px solid rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(12px)',
        whiteSpace: 'nowrap'
    },
    _small: {
        padding: '10.5px 14.5px',
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 100
    },
    _regular: {
        padding: '18.5px 38.5px',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 80
    }
});
